import { BookOption, BookOptionName, RoutePath } from "@app/constants";
import { Book } from "@app/types";
import { formatMoneyVN } from "@app/utils/util";
import { Images } from "@assets/images";
import { isNumber } from "@core/utils/util";
import clsx from "clsx";
import { useId } from "react";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";

interface BookItemProps {
  book: Book;
}

function BookItem({ book }: BookItemProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${RoutePath.BOOK_DETAIL}/${book.id}`);
  };

  const id = useId();

  const renderBadge = () => {
    if (book.bookOption === BookOption.PURCHASE && book.isAvailable) {
      return "Đã Mua";
    }

    return book.bookOption === BookOption.PURCHASE ? (
      <span>
        {formatMoneyVN(book.price)}
        <span className="underline">đ</span>
      </span>
    ) : (
      BookOptionName[book.bookOption]
    );
  };

  return (
    <div
      onClick={handleClick}
      className="flex-shrink-0 cursor-pointer relative"
    >
      <div
        className={clsx(
          "absolute z-10 top-0 right-0 px-3 py-[6px] rounded-tr-md rounded-bl-2xl text-sm font-medium font-[SVN-Gilroy] tracking-[0.028px]",
          {
            "bg-[#E6FFED] text-[#00A653]": book.bookOption === BookOption.FREE,
            "bg-[#FFFEE6] text-[#FFD500]": book.bookOption === BookOption.VIP,
            "bg-[#FFE4D6] text-[#FF7029]":
              book.bookOption === BookOption.PURCHASE,
          }
        )}
      >
        {renderBadge()}
      </div>
      <div className="relative">
        <img
          className="w-[200px] h-[300px] rounded-lg"
          src={book.thumbnails[0]}
          alt=""
        />
        <div
          className={clsx(
            "absolute rounded-bl-lg rounded-br-lg bottom-0 w-full h-9 bg-[linear-gradient(180deg,#1C1C1C66,#1C1C1C66)]",
            "flex justify-center gap-5"
          )}
        >
          <div className="flex items-center gap-1">
            <div>
              <img src={Images.HeartIcon.default} alt="" />
            </div>
            <div className="text-white font-[SVN-Gilroy] text-sm font-medium">
              {book.insight.likeCount ?? 0}
            </div>
          </div>
          <div className="flex items-center gap-1">
            <div>
              <img src={Images.Eye1Icon.default} alt="" />
            </div>
            <div className="text-white font-[SVN-Gilroy] text-sm font-medium">
              {book.insight.viewCount ?? 0}
            </div>
          </div>
        </div>
        {isNumber(book.listenPercent) && (
          <div className="absolute w-full -bottom-0.5 h-[6px]">
            <div className="h-full w-11/12 bg-[#ccccce] mx-auto rounded">
              <div
                className="h-full bg-red-500 rounded"
                style={{
                  width: `${book.listenPercent > 100 ? 100 : book.listenPercent}%`,
                }}
              ></div>
            </div>
          </div>
        )}
      </div>

      <p
        className="text-lg py-1 font-medium font-[SVN-Gilroy] max-w-[200px] truncate"
        data-tooltip-id={`tooltip-book-name-${id}`}
      >
        {book.name}
      </p>
      <Tooltip
        id={`tooltip-book-name-${id}`}
        place="top"
        variant="info"
        content={book.name}
      />
    </div>
  );
}

export default BookItem;
